module.exports = __webpack_public_path__ + "media/images/flags/1x1/tur-07c38b1e21008bfc675ce474ad340c9f.svg";